<template>
  <div class="tuolele-main-box store-add">
    <el-form
      ref="form"
      :model="storeInfo"
      label-width="185px"
      class="add-form"
      :class="{ edit: type == 'edit' }"
    >
      <el-form-item v-if="type == 'add'" label="选择公司" required>
        <el-select v-model="storeInfo.company_id" placeholder="请选择公司">
          <option value="">请选择公司</option>
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.company_name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="店铺名称" required>
        <el-input
          v-model="storeInfo.name"
          clearable
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="东风系统可操作业务" required>
        <el-checkbox-group v-model="businessCheckList" >
        <el-checkbox border  label="1" >托乐乐</el-checkbox>
        <el-checkbox border label="3">素质学</el-checkbox>
        <el-checkbox border label="2">天天陪读</el-checkbox>
      </el-checkbox-group>
      </el-form-item>
      <el-form-item v-if="type == 'add'" label="店铺初始扣费方式" required>
        <el-select v-model="storeInfo.ACTIVATED_CURRENCY" placeholder="请选择">
          <el-option label="常规" value="TIME_NORMAL" />
          <el-option label="假期" value="TIME_HOLIDAY" />
        </el-select>
      </el-form-item>
      <el-form-item label="选择省份" required>
        <el-select
          v-model="storeInfo.province_id"
          placeholder="省级地区"
          @change="choseProvince"
        >
          <el-option
            v-for="item in province"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="选择城市" required>
        <el-select
          v-model="storeInfo.city_id"
          placeholder="市级地区"
          @change="choseCity"
        >
          <el-option
            v-for="item in citylist"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="选择区/县" required>
        <el-select v-model="storeInfo.area_id" placeholder="区级地区">
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="绑定大区" required>
        <el-select v-model="storeInfo.class_id" clearable placeholder="选择大区">
          <el-option
            v-for="item in shopClassList"
            :key="item.class_id"
            :label="item.name"
            :value="item.class_id"
          />
        </el-select>
      </el-form-item> -->
      <el-form-item label="详细地址" >
        <el-input
          v-model="storeInfo.address"
          type="textarea"
          resize="none"
          :autosize="{ minRows: 3 }"
          placeholder="请输入"
        />
      </el-form-item>
      <el-form-item label="咨询电话" >
        <el-input
          v-model="storeInfo.extra.telephone"
          clearable
          placeholder="请输入"
        />
      </el-form-item>

      <el-form-item label="校区图片" >
        <UploadImg :photo="photo" @updateImg="updateImg" />
        <div class="upload-notice">
          建议校区照片上传尺寸比例为：3:2（例：1200px:800px）
        </div>
      </el-form-item>
      <el-form-item label="合同主体" >
        <el-input
          v-model="storeInfo.extra.contract"
          placeholder="请输入"
          clearable
        />
      </el-form-item>
      <el-form-item label="合同公章" >
        <UploadImg :photo="official_seal" @updateImg="updateOfficalSeal" />
        <div class="upload-notice">
          建议校区照片上传尺寸建议：525*525 png格式
        </div>
      </el-form-item>
      <!-- <el-form-item label="有效期" required>
        <el-date-picker
          v-model="storeInfo.valid_date"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        />
      </el-form-item> -->
      <!-- <el-form-item label="记账期" required>
        <el-date-picker
          v-model="storeInfo.charge_date"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        />
      </el-form-item> -->
      <!-- <el-form-item label="年费价格(乐币)" required>
        <el-radio-group v-model="storeInfo.annual_fee">
          <el-radio label="0">0</el-radio>
          <el-radio label="30000">30000</el-radio>
          <el-radio label="40000">40000</el-radio>
          <el-radio label="110000">110000</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <!-- <el-form-item label="学员服务费(乐币/人)" required>
        <el-radio-group v-model="storeInfo.student_service_fee">
          <el-radio label="0">0</el-radio>
          <el-radio label="5">5</el-radio>
          <el-radio label="8">8</el-radio>
          <el-radio label="10">10</el-radio>
        </el-radio-group>
      </el-form-item> -->
      
      <el-form-item class="form-buttom">
        <el-button
          type="primary"
          class="el-button-confirm"
          @click="shopImprove"
        >保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import mapJson from '@/assets/json/map.json'
import UploadImg from '@/components/toolbar/UploadImg.vue'
export default {
  name: 'StoreAdd',
  components: {
    UploadImg
  },
  data() {
    return {
      type: 'add',
      storeInfo: {
        id: '',
        company_id: '',
        name: '',
        address: '',
        province_id: '',
        city_id: '',
        area_id: '',
        extra: {
          telephone: '',
          photo: '',
          contract: '',
          official_seal: ''
        },
        
        // valid_date: '',
        // charge_date: '',
        // annual_fee: '',
        // student_service_fee: ''
        // class_id: ''
      },
      photo: '',
      official_seal: '',
      citylist: [],
      areaList: [],
      province: [],
      companyList: [],
      shopClassList: [],
      businessCheckList:[1]
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.storeInfo.id = this.$route.query.id
    this.province = mapJson
    if (this.storeInfo.id) {
      this.getShopInfo()
    }
    this.getCompanyList()
    this.fnGetShopClassList()
  },
  methods: {
    getShopInfo() {
      this.$http.getShopInfo({ id: this.storeInfo.id }).then(res => {
        this.storeInfo = res.data
        // res.data.contract = res.data.extra.contract || ''
        this.photo = this.storeInfo.extra.photo
        this.official_seal = this.storeInfo.extra.official_seal
        // console.log(this.storeInfo.extra)
        // this.official_seal = this.storeInfo.extra.official_seal || ''
        // console.log(this.storeInfo.contract)
        
        this.choseProvince(this.storeInfo.city_id, this.storeInfo.province_id)
        this.choseCity(this.storeInfo.area_id)
        this.businessCheckList = this.storeInfo.business
      })
    },
    getCompanyList() {
      this.$http.getCompanyList().then(res => {
        this.companyList = res.data
      })
    },
    fnGetShopClassList() {
      this.$http.getShopClassList().then(res => {
        this.shopClassList = res.data
      })
    },
    updateImg(photo) {
      this.photo = photo
    },
    updateOfficalSeal(photo) {
      this.official_seal = photo
    },
    shopImprove() {
      let storeInfo = {}
      if (this.type == 'add') {
        storeInfo = {
          company_id: this.storeInfo.company_id,
          name: this.storeInfo.name,
          address: this.storeInfo.address,
          province_id: this.storeInfo.province_id,
          city_id: this.storeInfo.city_id,
          area_id: this.storeInfo.area_id,
          telephone: this.storeInfo.extra.telephone,
          photo: this.photo,
          official_seal: this.official_seal,
          contract: this.storeInfo.contract,
          ACTIVATED_CURRENCY: this.storeInfo.ACTIVATED_CURRENCY,
          business:this.businessCheckList.join(',')
          // annual_fee: this.storeInfo.annual_fee,
          // student_service_fee: this.storeInfo.student_service_fee
          // class_id: this.storeInfo.class_id
        }
      } else {
        storeInfo = {
          id: this.storeInfo.id,
          name: this.storeInfo.name,
          address: this.storeInfo.address,
          province_id: this.storeInfo.province_id,
          city_id: this.storeInfo.city_id,
          area_id: this.storeInfo.area_id,
          telephone: this.storeInfo.extra.telephone,
          photo: this.photo,
          official_seal: this.official_seal,
          contract: this.storeInfo.extra.contract,
          business:this.businessCheckList.join(',')

          // annual_fee: this.storeInfo.annual_fee,
          // student_service_fee: this.storeInfo.student_service_fee
          // class_id: this.storeInfo.class_id
        }
      }
    

      for (const key in storeInfo) {
        if (storeInfo.name == '') {
          this.$message({
            type: 'error',
            message: '请完善店铺信息，*标内容必填'
          })
          return
        }
        if (storeInfo.business=='') {
          this.$message({
            type: 'error',
            message: '请选择东风系统可操作业务'
          })
          return
        }
      }
      this.$http.shopImprove(storeInfo).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.$router.go(-1)
        }
      })
    },
    // 选省
    choseProvince(e, m) {
      for (let index = 0; index < this.province.length; index++) {
        // 编辑时初始化数据
        if (e.length == 4 && m == this.province[index].id) {
          this.citylist = this.province[index]._child
          this.storeInfo.city_id = this.province[index]._child[0].id
          this.areaList = this.province[index]._child[0]._child
          this.storeInfo.area_id = this.province[index]._child[0]._child[0].id
        }
        // 联动城市 区域
        if (e === this.province[index].id) {
          // 判断直辖市 并且没有被选中过
          if (
            this.province[index].type == 1 &&
            this.province[index]._child.length != 1
          ) {
            const child = this.province[index]._child
            this.province[index]._child = []
            this.province[index]._child[0] = {
              id: this.province[index].id,
              name: this.province[index].name
            }
            this.province[index]._child[0]._child = child
            this.citylist = this.province[index]._child
            this.storeInfo.city_id = this.province[index]._child[0].id
            this.areaList = child
            this.storeInfo.area_id = child[0].id
          } else {
            this.citylist = this.province[index]._child
            this.storeInfo.city_id = this.province[index]._child[0].id
            this.areaList = this.province[index]._child[0]._child
            this.storeInfo.area_id = this.province[
              index
            ]._child[0]._child[0].id
          }
        }
      }
    },
    // 选市
    choseCity(e) {
      for (let index = 0; index < this.citylist.length; index++) {
        if (e === this.citylist[index].id) {
          this.areaList = this.citylist[index]._child
          this.storeInfo.area_id = this.citylist[index]._child[0].id
        }
      }
    }
  }
}
</script>
<style lang="scss">
.store-add {
  .el-input,
  .el-textarea {
    width: 280px;
  }
  .form-buttom {
    .el-form-item__content {
      margin-left: 170px !important;
    }
  }
  .add-form {
    &.edit {
      .el-form-item__label {
        width: 195px !important;
      }
      .el-form-item__content {
        margin-left: 120px !important;
      }
      .form-buttom .el-form-item__content {
        margin-left: 120px !important;
      }
    }
  }
  .el-form-item__content {
    line-height: 22px;
  }
  .el-radio-group {
    margin-top: 12px;
  }
}
</style>
